import {mapActions, mapMutations} from "vuex";
import moment from "moment";

export default {
  name: 'notificationsItem',
  //---components
  props: {
    data: {
      required: true
    }
  },
  //---data
  data () {
    return {
      postponeData: {
        list: [
          {
            id: 0,
            title: 'Tomorrow',
            daysBefore: 1,
          }, {
            id: 1,
            title: '2 days',
            daysBefore: 2,
          }, {
            id: 2,
            title: 'A week',
            daysBefore: 7,
          }, {
            id: 3,
            title: '2 week',
            daysBefore: 14,
          },
        ],
        current: null
      }
    }
  },
  //---hooks
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      updateNotifications: 'NOTIFICATIONS/NOTIFICATIONS_UPDATE_REQUEST_PUT',
      getNotifications: 'NOTIFICATIONS/NOTIFICATIONS_REQUEST_GET',
    }),
    gotoDashboardProperty(listing_id) {
      this.$router.push( {
        name: 'dashboard-property',
        params: {
          listing_id: listing_id
        }
      });
    },

    closeNotifications(data) {
      let dataForRequest = {
        id: data.id,
        payload: {
          status: '0',
          date: data.date
        }
      };
      this.loaderFlag(true);
      this.updateNotifications(dataForRequest).then(()=>{
        this.getNotifications().then(() => {
          this.$snotify.success('Notification Closed');
          this.loaderFlag(false);
        });
      });
    },
    changeNotificationDate(data) {
      if (this.postponeData.current !== null) {
        let dataForRequest = {
          id: data.id,
          payload: {
            status: data.status,
            date: moment().add(this.postponeData.current, 'days').format('YYYY-MM-DD')
          }
        };
        this.loaderFlag(true);
        this.updateNotifications(dataForRequest).then(()=>{
          this.postponeData.current = null;
          this.getNotifications().then(() => {
            this.$snotify.success('Notification Updated');
            this.loaderFlag(false);
          });
        });
      }
    }
  }
}